import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = { vins: string[] };
type Response = {
  data: { [key: string]: any };
};

export const useCarProjectedMonthlyIncomes = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['car-projected-monthly-incomes'],
  fetcher: (variables) => {
    return client
      .get(`v2/internal/partners/cars/projected-monthly-incomes`, {
        params: { vins: variables.vins },
      })
      .then((response) => {
        return response.data.data;
      });
  },
});
